module.exports = __webpack_public_path__ + "static/media/Aquarius-RegularSmallCaps.819bd1b6.ttf";